import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import moment from "moment";
import axios from "axios";
import {
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  valorAbsoluto,
} from "../../util/varios";

export const SolicitudTimbre = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [visible, setVisible] = useState("collapse");
  const [usuarios, setUsuarios] = useState([]);
  const [entes, setEntes] = useState([]);
  const [dependencias, setDependencias] = useState([]);
  const [tramites, setTramites] = useState([]);
  const [ut, setUt] = useState("0.00");
  const [tramite, setTramite] = useState({
    idtramite: "0",
    iddependencia: "",
    idente: "",
    nombre: "",
    monto: 0.0,
    fijo: true,
    factorcalculo: 1,
    titulo: "CANTIDAD",
    informacion: "",
  });
  const [values, setValues] = useState({
    idsolicitud: "0",
    cedula: "",
    nombre: "",
    idente: "",
    iddependencia: "",
    idtramite: "",
    informacion: "",
    numtrasaren: "",
    rutafct: "",
    monto: "",
    valorute: "",
    montocapital: "",
    ut: "",
    idusuarioweb: "",
    estatus: 0,
    fechasolicitud: moment(fechaSistema).format("YYYY-MM-DD")
  });
  const [deshabilitado, setDeshabilitado] = useState(false);

  const txtIdsolicitud = useRef();
  const cmbUsusarioweb = useRef();
  const txtCedula = useRef();
  const txtNombre = useRef();
  const txtEnte = useRef();
  const txtDependencia = useRef();
  const txtTramite = useRef();
  const txtInformacion = useRef();
  const txtNumtrasaren = useRef();
  const txtMonto = useRef();
  const txtValorute = useRef();
  const txtMontoCapital = useRef();
  const txtMontoUTE = useRef();
  const txtFecha = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();

  const onChange = (event) => {
    if (event.target.name === "idente") {
      if (event.target.value !== "") {
        let tipo = event.target.value.split("-");
        Seleccionardependencias(false, tipo[0]);
        txtMonto.current.value = "0,00";
        txtMontoUTE.current.value = "0,00";
        txtInformacion.current.value = "";
        txtDependencia.current.focus();
        setTramite({ ...tramite, fijo: true });
      } else {
        setDependencias([]);
        setTramites([]);
        setTramite({ ...tramite, fijo: true });
        txtMonto.current.value = "0,00";
        txtMontoUTE.current.value = "0,00";
        txtInformacion.current.value = "";
      }
    } else if (event.target.name === "iddependencia") {
      if (event.target.value !== "") {
        Seleccionartramites(false, event.target.value);
        setTramite({ ...tramite, fijo: true });
        txtMonto.current.value = "0,00";
        txtMontoUTE.current.value = "0,00";
        txtInformacion.current.value = "";
        txtTramite.current.focus();
      } else {
        setTramites([]);
        setTramite({ ...tramite, fijo: true });
        txtMonto.current.value = "0,00";
        txtMontoUTE.current.value = "0,00";
        txtInformacion.current.value = "";
      }
    } else if (event.target.name === "idtramite") {
      if (event.target.value !== "") {
        const tram = tramites.filter(
          (a) => a.idtramite.toString() === event.target.value
        )[0];
        setTramite(tram);
        txtInformacion.current.value = tram.informacion;
        let monto = tram.monto;
        txtMonto.current.value = formatMoneda(
          (parseFloat(monto) * props.valorut)
            .toString()
            .replace(",", "")
            .replace(".", ","),
          ",",
          ".",
          2
        );
        if (tram.fijo) {
          txtMontoUTE.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }

        btnAcepta.current.focus();
      } else {
        txtMonto.current.value = "0,00";
        txtMontoUTE.current.value = "0,00";
        txtInformacion.current.value = "";
        setTramite({ ...tramite, fijo: true });
      }
    } else {
      event.target.value = event.target.value.toUpperCase();
    }

    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const onChangeT = (event) => {
    if (event.which === 13) {
      if (event.target.name === "cedula") {
        txtNombre.current.focus();
      } else if (event.target.name === "nombre") {
        txtEnte.current.focus();
      }
    }
  };

  const nombreDireccion = (idente, iddependencia, dependencia) => {
    let nombre = dependencia;
    if (parseInt(idente) === 134 && parseInt(iddependencia) === 6) {
      nombre =
        "(SATRIMSCA) Servicio Autónomo de Administración Tributaria del Municipio San Carlos";
    } else if (parseInt(idente) === 144 && parseInt(iddependencia) === 6) {
      nombre =
        "(SATRIMUTI) Servicio Autónomo de Administración Tributaria del Municipio Tinaco";
    } else if (parseInt(idente) === 149 && parseInt(iddependencia) === 6) {
      nombre =
        "(SAATRI) Servicio Autónomo de Administración Tributaria del Municipio Tinaquillo";
    }

    return nombre;
  };

  const seleccionarUsuarios = () => {
    let campos = "idusuarioweb, trim(login) as login";
    let nomtab = "usuarioweb";
    let orden = "idusuarioweb desc";

    let endpoint = `${op.conexion}/api/solicitudtimbre/consultar?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setUsuarios(response.data);
          } else {
            setUsuarios([]);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SeleccionarRegistros = () => {
    setActivate(true);

    let campos = `trim(nombre) as nombre, idagente, idtipoente`;
    let nomtab = "agente";
    let condi = `ente=true`;
    let orden = "idagente asc";

    let endpoint = `${op.conexion}/api/consultaweb/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setEntes(response.data);
          if (props.operacion > 1) {
            txtEnte.current.value = `${props.solicitud.tipoente}-${props.solicitud.idente}`;
            Seleccionardependencias(true, props.solicitud.tipoente);
          }
        }
      })
      .catch(function (error) {
        console.error(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const Seleccionardependencias = (desde, id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "dependencias";
    let nomid = "tipoente";

    let endpoint = `${op.conexion}/api/consultaweb/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let depe = [];
          let data = response.data;
          let tipo = txtEnte.current.value.split("-");
          for (let i = 0; i < data.length; i++) {
            data[i].nombre = nombreDireccion(
              tipo[1],
              data[i].iddependencia,
              data[i].nombre
            );
          }
          setDependencias(data);
          setTramites([]);
          if (desde && props.operacion > 1) {
            txtDependencia.current.value = props.solicitud.iddependencia;
            Seleccionartramites(true, props.solicitud.iddependencia);
          } else {
            txtDependencia.current.value = "";
            txtTramite.current.value = "";
            txtMonto.current.value = "0,00";
            //  txtValorute.current.value = "0,00";
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const Seleccionartramites = (desde, id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "tramites";
    let nomid = "iddependencia";

    let endpoint = `${op.conexion}/api/consultaweb/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setTramites(response.data);
          if (desde && props.operacion > 1) {
            txtTramite.current.value = props.solicitud.idtramite;
            const trami = response.data.filter(
              (a) => a.idtramite.toString() === props.solicitud.idtramite
            )[0];
            setTramite(trami);

            txtMontoUTE.current.value = formatMoneda(
              props.solicitud.montoute
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
          } else {
            txtTramite.current.value = "";
            txtMonto.current.value = "0,00";
            txtMontoUTE.current.value = "0,00";
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtCedula.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir Cedula/Rif.",
        icono: "informacion",
      });
      sigue = false;
      txtCedula.current.focus();
    } else if (txtNombre.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Nombre.",
        icono: "informacion",
      });
      sigue = false;
      txtNombre.current.focus();
    } else if (txtEnte.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar el Ente.",
        icono: "informacion",
      });
      sigue = false;
      txtEnte.current.focus();
    } else if (txtDependencia.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar la Dependencia.",
        icono: "informacion",
      });
      sigue = false;
      txtDependencia.current.focus();
    } else if (txtTramite.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Tramite.",
        icono: "informacion",
      });
      sigue = false;
      txtTramite.current.focus();
    } else if (
      txtEnte.current.value.trim() === "17" &&
      txtNumtrasaren.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe introducir el numero de tramite por el saren.",
        icono: "informacion",
      });
      sigue = false;
      txtNumtrasaren.current.focus();
    } else if (txtInformacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe introducir la informacion",
        icono: "informacion",
      });
      sigue = false;
      txtInformacion.current.focus();
    } /*  else if (
      txtEnte.current.value.trim() === "17" &&
      txtRutafct.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe introducir el folio/contenedor/talonarios",
        icono: "informacion",
      });
      sigue = false;
      txtRutafct.current.focus();
    }  */ else if (txtMonto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe introducir el valor estimado.",
        icono: "informacion",
      });
      sigue = false;
      txtMonto.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe introducir la fecha de emision.",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (
      !tramite.fijo &&
      (txtValorute.current.value.trim() === "" ||
        txtValorute.current.value.trim() === "0,00")
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe introducir el valor UTE.",
        icono: "informacion",
      });
      sigue = false;
      txtValorute.current.focus();
    } else if (
      !tramite.fijo &&
      (txtMontoCapital.current.value.trim() === "" ||
        txtMontoCapital.current.value.trim() === "0,00")
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe introducir el " + tramite.titulo,
        icono: "informacion",
      });
      sigue = false;
      txtMontoCapital.current.focus();
    } else if (sigue) {
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/solicitudtimbre/actualizar/${props.operacion}`;
    let body;
    setActivate(true);

    let timbre = [];
    timbre.push({
      idsolicitud: parseInt(values.idsolicitud),
      cedula: txtCedula.current.value.trim(),
      nombre: txtNombre.current.value.trim(),
      idente: txtEnte.current.value.split("-")[1],
      iddependencia: txtDependencia.current.value.trim(),
      idtramite: txtTramite.current.value.trim(),
      ut: ut,
      informacion: txtInformacion.current.value.trim(),
      monto: txtMonto.current.value.trim().replace(/\./g, "").replace(",", "."),
      montoute: txtMontoUTE.current.value
        .trim()
        .replace(/\./g, "")
        .replace(",", "."),
      montocapital: tramite.fijo
        ? "0.00"
        : txtMontoCapital.current.value
            .trim()
            .replace(/\./g, "")
            .replace(",", "."),
      valorute: tramite.fijo
        ? txtMontoUTE.current.value.trim().replace(/\./g, "").replace(",", ".")
        : txtValorute.current.value.trim().replace(/\./g, "").replace(",", "."),
      idusuarioweb: cmbUsusarioweb.current.value,
      fechasolicitud: txtFecha.current.value,
      estatus: values.estatus,
    });

    body = {
      timbre,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    let mon = 0.0;
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.target.name === "valorute") {

         let ut = props.valorut;
         let valorute = parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", "."));
       
         mon = ut * valorute;
          
        txtMonto.current.value = formatMoneda(
          mon.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );

        txtMontoUTE.current.value = formatMoneda(
          (mon / props.valorut).toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
      }

      if (event.target.name === "montocapital") {
        let ut = props.valorut;
        let ute = parseFloat(txtValorute.current.value.trim().replace(/\./g, "").replace(",", "."));
        let montocapital = parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", "."));
        let montoute = 0.00;
       
         mon = ute * montocapital;    
         mon = mon / 100;
         montoute = (mon/ut);
         
         if (txtTramite.current.value === "84" || txtTramite.current.value === "93") {
          if (montoute > 500) {
            montoute = 500.00;
            mon = 500 * ut;            
          }          
         }

        txtMonto.current.value = formatMoneda(
          (mon).toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );

        txtMontoUTE.current.value = formatMoneda(
          (montoute)
            .toString()
            .replace(",", "")
            .replace(".", ","),
          ",",
          ".",
          2
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };


  const handleInputCantChange = (event) => {
    let mon = 0.0;
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.name === "montocapital") {
        mon =
          parseFloat(ut) *
          parseFloat(
            txtValorute.current.value
              .trim()
              .replace(/\./g, "")
              .replace(",", ".")
          ) *
          parseFloat(event.target.value.trim());
        txtMonto.current.value = formatMoneda(
          mon.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );

        txtMontoUTE.current.value = formatMoneda(
          (mon / props.valorut).toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const blanquear = () => {
    setActivate(false);
    setDeshabilitado(false);
    setEntes([]);
    setDependencias([]);
    setTramites([]);
    setVisible("collapse");
    setTramite({
      idtramite: "0",
      iddependencia: "",
      idente: "",
      nombre: "",
      monto: 0.0,
      fijo: true,
      factorcalculo: 1,
      titulo: "CANTIDAD",
      informacion: "",
    });
    setValues({
      idsolicitud: "0",
      cedula: "",
      nombre: "",
      idente: "",
      iddependencia: "",
      idtramite: "",
      informacion: "",
      numtrasaren: "",
      rutafct: "",
      monto: "",
      valorute: "",
      montocapital: "",
      ut: "",
      idusuarioweb: "",
      estatus: 0,
      fechasolicitud: moment(fechaSistema).format("YYYY-MM-DD")
    });
  };

  const handleCloseSi = () => {
    Actualizar();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    props.onHide(1);
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = () => {
    blanquear();
    props.onHide(0);
  };

  useEffect(() => {
    if (!tramite.fijo) {
      txtValorute.current.value = formatMoneda(
        tramite.monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
  }, [tramite]);

  useEffect(()=> {
    if (props.operacion !== 1) {
      txtEnte.current.value=`${props.solicitud.tipoente}-${props.solicitud.idente}`;     
    }
  },[entes]);

  useEffect(()=> {
    if (props.operacion !== 1) {
      txtDependencia.current.value=props.solicitud.iddependencia;     
    }
  },[dependencias]);

  useEffect(()=> {
    if (props.operacion !== 1) {
      txtTramite.current.value=props.solicitud.idtramite;     
    }
  },[tramites]);

  useEffect(() => {
    seleccionarUsuarios();
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        SeleccionarRegistros();
        if (props.operacion !== 1) {
          setValues(props.solicitud);
          setUt(props.solicitud.ut);
          txtFecha.current.value = moment(props.solicitud.fechasolicitud).format(
            "YYYY-MM-DD"
          )
          if (props.operacion === 2) {
            setDeshabilitado(false);
          } else {
            setDeshabilitado(true);
          }
        } else {
          setUt(props.valorut);
          setDeshabilitado(false);
        }
      }}
    >
      <Modal.Header className="azulGradiant2">
        <Modal.Title style={{ color: "#fff" }}>
          Solicitud Timbre Fiscal Electrónico.
        </Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body
        className="amanecergris"
        style={{ backgroundColor: "#FFF", color: "" }}
      >
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div className="col-md-12" style={{ height: "65vh", overflow: "auto" }}>
        <div className="input-group input-group-sm mb-3 col-md-3">
            <span className="input-group-text" style={{ backgroundColor: "#55acee", fontSize: 12 }} id="inputGroup-sizing-sm">
              Fecha
            </span>
            <input
              type="date"
              name="desde"
              onChange={onChange}
              ref={txtFecha}
              disabled={deshabilitado}
              defaultValue={moment(fechaSistema).format("YYYY-MM-DD")}
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>
          <div
            className="row col-md-12"
            style={{ fontFamily: "Times New Roman, Times, serif" }}
          >
            <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px" }}
              >
                Datos del Usuario
              </legend>
              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  Usuario:
                </label>
                <select
                  name="idusuarioweb"
                  disabled={deshabilitado}
                  defaultValue={
                    props.solicitud &&
                    props.solicitud.idusuarioweb
                  }
                  className="form-control"
                  ref={cmbUsusarioweb}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                >
                  <option value="">- seleccione un usuario -</option>
                  {usuarios &&
                    usuarios.map((item, i) => (
                      <option
                        key={i}
                        value={item.idusuarioweb}
                      >
                        {item.login}
                      </option>
                    ))}
                </select>
              </div>
             
            </fieldset>

            <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px" }}
              >
                Datos de la Solicitud
              </legend>

              <div className="input-group input-group-sm col-sm-4 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  CEDULA / RIF:
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  name="cedula"
                  autoComplete="off"
                  ref={txtCedula}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                  value={values.cedula}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="C.I./RIF"
                  title="Debe escribir en el RIF G, J, C, V o E mas el número"
                  maxLength={11}
                />
              </div>

              <div className="input-group input-group-sm col-sm-8 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  NOMBRE / RAZÓN SOCIAL:
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  name="nombre"
                  autoComplete="off"
                  ref={txtNombre}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                  value={values.nombre}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="Nombre/Razón Social"
                />
              </div>

              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  ENTE:
                </label>
                <select
                  name="idente"
                  disabled={deshabilitado}
                  defaultValue={
                    props.solicitud &&
                    `${props.solicitud.tipoente}-${props.solicitud.idente}`
                  }
                  className="form-control"
                  ref={txtEnte}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                >
                  <option value="">- Seleccione un ente -</option>
                  {entes &&
                    entes.map((item, i) => (
                      <option
                        key={i}
                        value={`${item.idtipoente}-${item.idagente}`}
                      >
                        {item.nombre}
                      </option>
                    ))}
                </select>
              </div>

              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  DEPENDENCIA:
                </label>
                <select
                  name="iddependencia"
                  defaultValue={
                    props.solicitud && props.solicitud.iddependencia
                  }
                  disabled={deshabilitado}
                  className="form-control"
                  ref={txtDependencia}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                >
                  <option value="">- Seleccione una dependencia -</option>
                  {dependencias &&
                    dependencias.map((item, i) => (
                      <option key={i} value={item.iddependencia}>
                        {item.nombre}
                      </option>
                    ))}
                </select>
              </div>

              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  TRAMITE:
                </label>
                <select
                  onChange={onChange}
                  onKeyUp={onChangeT}
                  disabled={deshabilitado}
                  name="idtramite"
                  defaultValue={props.solicitud && props.solicitud.idtramite}
                  ref={txtTramite}
                  className="form-control"
                >
                  <option value="">- Seleccione un trámite -</option>
                  {tramites &&
                    tramites.map((item, i) => (
                      <option key={i} value={item.idtramite}>
                        {item.nombre}
                      </option>
                    ))}
                </select>
              </div>
              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  INFORMACIÓN:
                </label>
                <input
                  type="text"
                  disabled
                  name="informacion"
                  ref={txtInformacion}
                  defaultValue={tramite.informacion}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="Información del tramite"
                />
              </div>
            </fieldset>
            {/* 
              <fieldset style={{ visibility: visible }} className=' row col-sm-12 mx-auto border-azul rounded'>
              <legend className="float-none w-auto" style={{ fontSize: '15px' }}>Tramites por el Saren</legend>
              <div className="input-group input-group-sm col-sm-4 mb-3">
                <label className="input-group-text" style={{ backgroundColor: "#55acee" }} id="inputGroup-sizing-sm">Número de trámite PUB SAREN:</label>
                <input type="text" disabled={deshabilitado} name='numtrasaren' autoComplete='off' ref={txtNumtrasaren} onChange={onChange} value={values.numtrasaren} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" placeholder="Si el tramite es por el SAREN, es obligatorio colar el número de tramite de la PUB. Ej: 410.2022.1.001" maxLength={15} />
              </div>
  
  

  
              <div className="input-group input-group-sm col-sm-4 mb-3">
                <label className="input-group-text" style={{ backgroundColor: "#55acee" }} id="inputGroup-sizing-sm"># Foli/Contenedor/Talonarios</label>
                <input type="text" disabled={deshabilitado} name='rutafct' autoComplete='off' ref={txtRutafct} onChange={onChange} value={values.rutafct} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" placeholder="# Fol/Contendor/Talonarios" title="# Folios/Días/Talonarios" />
              </div>
  
              </fieldset> */}

            {!tramite.fijo && (
              <fieldset className=" row col-sm-12 mx-auto border-azul rounded justify-content-between">
                <legend
                  className="float-none w-auto"
                  style={{ fontSize: "15px" }}
                >
                  Datos del Tramite
                </legend>
                <div className="input-group input-group-sm col-sm-3 mb-3">
                  <input
                    type="text"
                    disabled
                    name="valorute"
                    autoComplete="off"
                    ref={txtValorute}
                    defaultValue={
                      values.valorute !== null
                        ? formatMoneda(
                            values.valorute.replace(",", "").replace(".", ","),
                            ",",
                            ".",
                            2
                          )
                        : "0,00"
                    }
                    className="form-control text-end"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    placeholder="0,00"
                    title="valor del tramite"
                  />
                  <label
                    className="input-group-text"
                    style={{ backgroundColor: "#55acee", fontSize: 12 }}
                    id="inputGroup-sizing-sm"
                  >
                    %
                  </label>
                </div>

                <span
                  className="col-1 mb-3"
                  style={{
                    color: "#000000",
                    fontSize: 20,
                    fontWeight: "bold",
                  }}
                  id="inputGroup-sizing-sm"
                >
                  x
                </span>

                {!tramite.fijo && (
                  <div className="input-group input-group-sm col-sm-4 mb-3">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "#55acee" }}
                      id="inputGroup-sizing-sm"
                    >
                      {tramite.titulo}
                    </label>
                    {tramite.factorcalculo === 1 ? (
                      <input
                        type="text"
                        disabled={deshabilitado}
                        name="montocapital"
                        autoComplete="off"
                        ref={txtMontoCapital}
                        onFocus={seleccionarCampo}
                        onBlur={handleInputMontoChange}
                        onKeyUp={handleInputMontoChange}
                        defaultValue={
                          values.montocapital !== null
                            ? formatMoneda(
                                values.montocapital
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                            : "0,00"
                        }
                        className="form-control text-end"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        placeholder="0,00"
                        title="valor del capital"
                      />
                    ) : (
                      <input
                        type="number"
                        disabled={deshabilitado}
                        name="montocapital"
                        autoComplete="off"
                        min={1}
                        ref={txtMontoCapital}
                        onFocus={seleccionarCampo}
                        onBlur={handleInputCantChange}
                        onKeyUp={handleInputCantChange}
                        defaultValue={
                          values.montocapital !== null
                            ? valorAbsoluto(values.montocapital) 
                            : "1"
                        }
                        className="form-control text-end"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        placeholder="1"
                        title="valor del capital"
                      />
                    )}
                  </div>
                )}
              </fieldset>
            )}
            <fieldset className=" row col-sm-12 mx-auto border-azul rounded justify-content-end">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px" }}
              >
                Monto Total a Pagar UTE/BS
              </legend>

              <div className="input-group input-group-sm col-sm-3 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee" }}
                  id="inputGroup-sizing-sm"
                >
                  VALOR UTE
                </label>
                <input
                  type="text"
                  disabled
                  name="valorut"
                  value={formatMoneda(
                    ut.toString().replace(",", "").replace(".", ","),
                    ",",
                    ".",
                    2
                  )}
                  className="form-control text-end"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="0,00"
                  title="valor del ut"
                />
              </div>
              <div className="input-group input-group-sm col-sm-3 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee" }}
                  id="inputGroup-sizing-sm"
                >
                  MONTO UTE
                </label>
                <input
                  type="text"
                  disabled
                  name="montoute"
                  autoComplete="off"
                  ref={txtMontoUTE}
                  defaultValue="0,00"
                  className="form-control text-end"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="0,00"
                  title="valor estimado"
                />
              </div>

              <div className="input-group input-group-sm col-sm-3 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee" }}
                  id="inputGroup-sizing-sm"
                >
                  MONTO BS
                </label>
                <input
                  type="text"
                  disabled
                  name="monto"
                  autoComplete="off"
                  ref={txtMonto}
                  onFocus={seleccionarCampo}
                  onBlur={handleInputMontoChange}
                  onKeyUp={handleInputMontoChange}
                  defaultValue={
                    values.monto !== null
                      ? formatMoneda(
                          values.monto.replace(",", "").replace(".", ","),
                          ",",
                          ".",
                          2
                        )
                      : "0,00"
                  }
                  className="form-control text-end"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="0,00"
                  title="valor estimado"
                />
              </div>
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          disabled={props.operacion === 4 ? true : false}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/timbre_fiscal_electronico/modal_timbre_fiscal_electronico.js